import ChatInputAdorements from "../../../../reusable/Chat/PromptInput/ChatInputAdorements";
import ChatPersonaSelectButton from "src/reusable/Chat/PromptInput/ChatPersonaSelectButton";
import ChatResponseModeToggle from "src/reusable/Chat/PromptInput/ChatResponseModeToggle";
import { Stack } from "@mui/material";
import {
  TokenUsageGauge,
  type TokenUsageData,
} from "src/reusable/Chat/TokenUsageGauge";

type ChatInputButtonsProps = {
  isInputting: boolean;
  isChatLoading: boolean;
  isGenerating: boolean;
  handleFormSubmit: (event: React.FormEvent | React.KeyboardEvent) => void;
  onStopChat: () => void;
  tokenUsage?: TokenUsageData | null;
};

const AAChatInputButtons = ({
  isInputting,
  isChatLoading,
  isGenerating,
  handleFormSubmit,
  onStopChat,
  tokenUsage,
}: ChatInputButtonsProps) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="flex-end"
      sx={{ width: "100%" }}
      gap={2}
    >
      <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
        <ChatPersonaSelectButton />
        <ChatResponseModeToggle />
      </Stack>
      <Stack direction="row" justifySelf="flex-end" alignItems="center" gap={2}>
        {tokenUsage && (
          <TokenUsageGauge tokenUsage={tokenUsage} variant="circular" />
        )}
        <ChatInputAdorements
          isInputting={isInputting}
          isChatLoading={isChatLoading}
          isGenerating={isGenerating}
          handleFormSubmit={handleFormSubmit}
          onStopChat={onStopChat}
        />
      </Stack>
    </Stack>
  );
};

export default AAChatInputButtons;
